import React from 'react';
import { Truck, Package, RotateCcw, Clock, MapPin, CreditCard } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const ShippingAndExchange11 = () => {
    const shippingOptions = [
        { icon: Truck, title: 'Standard Shipping', description: '5-7 business days across India', detail: 'Free on orders above \u20B92,999' },
        { icon: Package, title: 'Express Delivery', description: '2-3 business days', detail: '\u20B9299 flat rate' },
        { icon: MapPin, title: 'Store Pickup', description: 'Ready in 24 hours', detail: 'Free at our Bangalore studio' },
        { icon: Clock, title: 'Same-Day Delivery', description: 'Select cities only', detail: 'Available in Bangalore, Mumbai, Delhi' },
    ];

    const returnSteps = [
        { step: '01', title: 'Initiate Return', description: 'Log into your account, go to Orders, and select the item you wish to return within 15 days of delivery.' },
        { step: '02', title: 'Pack the Item', description: 'Place the item in its original packaging with tags attached. Include the invoice copy.' },
        { step: '03', title: 'Schedule Pickup', description: 'Our courier partner will pick up the package from your doorstep within 2 business days.' },
        { step: '04', title: 'Receive Refund', description: 'Once we receive and inspect the item, your refund will be processed within 7-10 business days.' },
    ];

    const policies = [
        { title: 'Eligible for Returns', items: ['Unworn, unwashed items with original tags', 'Items returned within 15 days of delivery', 'Items in original packaging', 'Defective or damaged products'] },
        { title: 'Not Eligible for Returns', items: ['Custom-tailored garments', 'Altered or modified items', 'Items without original tags or packaging', 'Items marked as final sale'] },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                <main className="pt-[100px] pb-16 px-4 sm:px-6">
                    <div className="max-w-[1000px] mx-auto">
                        {/* Header */}
                        <div className="text-center mb-12">
                            <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                            <h1 className="text-3xl sm:text-4xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>
                                SHIPPING & RETURNS
                            </h1>
                        </div>

                        {/* Shipping Options */}
                        <div className="mb-16">
                            <h2 className="text-xl font-semibold mb-6" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>DELIVERY OPTIONS</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {shippingOptions.map(({ icon: Icon, title, description, detail }, i) => (
                                    <div key={i} className="flex gap-4 p-5" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                                        <div className="w-10 h-10 flex items-center justify-center flex-shrink-0" style={{ border: '1px solid #D97706' }}>
                                            <Icon size={18} style={{ color: '#D97706' }} />
                                        </div>
                                        <div>
                                            <h3 className="text-sm font-semibold mb-1" style={{ color: '#FAFAF9' }}>{title}</h3>
                                            <p className="text-xs mb-1" style={{ color: '#A8A29E' }}>{description}</p>
                                            <p className="text-xs font-semibold" style={{ color: '#D97706' }}>{detail}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Return Process */}
                        <div className="mb-16">
                            <h2 className="text-xl font-semibold mb-6" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>RETURN PROCESS</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                {returnSteps.map((item, i) => (
                                    <div key={i} className="p-5" style={{ backgroundColor: '#292524', borderLeft: '3px solid #D97706' }}>
                                        <span className="text-3xl font-bold block mb-3" style={{ fontFamily: "'Oswald', sans-serif", color: '#44403C' }}>{item.step}</span>
                                        <h3 className="text-sm font-semibold mb-2" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase' }}>{item.title}</h3>
                                        <p className="text-xs leading-relaxed" style={{ color: '#A8A29E' }}>{item.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Policies */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {policies.map((policy, i) => (
                                <div key={i} className="p-6" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                                    <h3 className="text-sm font-semibold mb-4" style={{ fontFamily: "'Oswald', sans-serif", color: i === 0 ? '#D97706' : '#EF4444', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                        {policy.title}
                                    </h3>
                                    <ul className="space-y-2">
                                        {policy.items.map((item, j) => (
                                            <li key={j} className="flex items-start gap-2 text-sm" style={{ color: '#A8A29E' }}>
                                                <span style={{ color: i === 0 ? '#D97706' : '#EF4444', marginTop: '6px', fontSize: '6px' }}>&#9679;</span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default ShippingAndExchange11;
